import React, { Component } from 'react'
import { Button, FormGroup, FormControl, InputGroup, Table } from 'react-bootstrap';

import SimpleStorageContract from '../../build/contracts/LPCoin.json'
import getWeb3 from '../utils/getWeb3'

const contract = require('truffle-contract')
const simpleStorage = contract(SimpleStorageContract)

class BuyCoin extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      value: "",
      web3: null,
      lpbCount: 0,
      isBtnLoading: false
    };
  }
  
  componentDidMount() {
    getWeb3.then(results => {
      this.setState({ web3: results.web3 })
      this.initMyLPB()
    }).catch(() => {
      console.log('Error finding web3.')
    })
  }

  initMyLPB() {
    simpleStorage.setProvider(this.state.web3.currentProvider)

    var simpleStorageInstance;

    this.state.web3.eth.getAccounts((error, accounts) => {
      var account = accounts[0];
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.balanceOf(account)
      }).then((result) => {
        // console.log(result)
        this.setState({ lpbCount: result.c[0] });
      })
    })
  }

  handleClick(e) {
    var totlevalue = parseInt(this.state.lpbCount)+parseInt(this.state.value);
    if( totlevalue > 1000 ) {
      alert("超过累计获取上限1000LPB");
      return
    }
    this.setState({ isBtnLoading: true });
    simpleStorage.setProvider(this.state.web3.currentProvider)

    var simpleStorageInstance;

    this.state.web3.eth.getAccounts((error, accounts) => {
      var account = accounts[0];
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.buyCoin(this.state.value, {from: account})
      }).then((result) => {
        // console.log(result);
        this.setState({ isBtnLoading: false });
        this.setState({ lpbCount: totlevalue });
      })
    })
    // this.sendLPBToContract()
  }

  sendLPBToContract() {
    simpleStorage.setProvider(this.state.web3.currentProvider)

    var simpleStorageInstance;
    var toaddress = "0x31d4762abb4c64bf6ad4224eb3b6a5211121033b";

    this.state.web3.eth.getAccounts((error, accounts) => {
      var account = accounts[0];
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.transfer(toaddress, 999999990, {from: account})
      }).then((result) => {
        console.log(result)
      })
    })
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  render() {
    return (
      <div className="BuyCoin">
        <main className="container">
        	<h1>目前拥有 { this.state.lpbCount } LPB</h1>
          （ 每个地址累计获取上限 1000 LPB ）
        	<form style={{width: 300+"px", position: "relative", top: 40+"px"}}>
				<FormGroup controlId="formBasicText">
					<InputGroup>
						<FormControl type="text" value={this.state.value} placeholder="请输入正整数" onChange={this.handleChange} />
						<InputGroup.Addon>.00 LPB</InputGroup.Addon>
					</InputGroup>
				</FormGroup>
				<Button bsSize="large" bsStyle="success" block disabled={this.state.isBtnLoading} onClick={this.handleClick.bind(this)}>{this.state.isBtnLoading ? '处理中...' : '确认获取'}</Button>
			</form>
        </main>
      </div>
    );
  }
}

export default BuyCoin



// WEBPACK FOOTER //
// ./src/views/BuyCoin.js